<template>
    <div class="array-container background-container">
      <ul class="array-list">
        <li v-for="(item, index) in displayedArray" :key="index" class="array-item">
        <div v-if="isPrimitive(item)" class="index-and-value-container">
          <span class="array-index text">{{ getItemIndex(index) }}</span>
          <span v-if="isPrimitive(item)" class="primitive-value">
            {{ formatFirestoreTimestamp(item) }}
          </span>
          <div v-if="isPrimitive(item) && collection.allowArrayEditFields && collection.allowArrayEditFields.includes(name)" class="button-container">
            <button
              class="btn add-filter-btn edit-btn"
              @click="openPopover(index, item)"
            >
              <i class="ri-pencil-fill medium-icon"></i>
            </button>
            <button
              class="btn add-filter-btn delete-btn ml-1"
              @click="removeItem(index)"
            >
              <i class="ri-delete-bin-fill medium-icon"></i>
            </button>
          </div>
        </div>
          <div v-if="!isPrimitive(item)" class="object-type-container">
            <div class="index-box">
              <span class="array-index text">{{ getItemIndex(index) }}</span>
              <div class="button-container">
                <button
                  class="btn add-filter-btn delete-btn"
                  @click="removeItem(key)"
                >
                  <!-- <i class="ri-delete-bin-fill medium-icon"></i> -->
                </button>
              </div>
            </div>
            <div class="object-container">
              <div v-for="(value, key) in item" :key="key" class="object-field">
                <span class="object-key muted-text">{{ key }}:</span>
                <span class="object-value text">{{ formatFirestoreTimestamp(value) }}</span>
                <div class="button-container" v-if="collection.allowArrayEditFields && collection.allowArrayEditFields.includes(name)">
                  <button
                    class="btn add-filter-btn edit-btn"
                    @click="openPopover(index, value)"
                  >
                    <i class="ri-pencil-fill medium-icon"></i>
                  </button>
                  <button
                    class="btn add-filter-btn delete-btn ml-1"
                    @click="removeItem(key)"
                  >
                    <i class="ri-delete-bin-fill medium-icon"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="pagination-container">
          </div>
        </div>
        </li>
      </ul>
      <div v-if="array.length > pageSize" class="pagination-container">
        <el-pagination
          small
          background
          layout="prev, pager, next"
          :total="array.length"
          :current-page="currentPage"
          :page-size="pageSize"
          class="mt-4"
          @current-change="handlePageChange"
        />
      </div>
    </div>
  </template>

<script>
import { ref, onMounted, computed } from 'vue'
import { updateDocument } from '../../../services/useDocument'
import { deleteField } from 'firebase/firestore'
import { ElMessageBox } from 'element-plus'
import { format } from 'date-fns'

export default {
  props: {
    documentId: String,
    collection: Object,
    name: String,
    array: Array
  },
  setup (props, context) {
    const currentPage = ref(1)
    const pageSize = 20
    const displayedArray = computed(() => {
      const start = (currentPage.value - 1) * pageSize
      return props.array.slice(start, start + pageSize)
    })
    const isPrimitive = (value) => {
      return (
        typeof value !== 'object' || value === null || Array.isArray(value)
      )
    }

    const handlePageChange = (newPage) => {
      currentPage.value = newPage
    }

    const formatFirestoreTimestamp = (timestamp) => {
      if (timestamp && timestamp.toDate) {
        return format(timestamp.toDate(), 'yyyy-MM-dd HH:mm:ss:sss')
      }
      return timestamp
    }

    const getItemIndex = (index) => {
      return (currentPage.value - 1) * pageSize + index
    }

    return {
      isPrimitive,
      formatFirestoreTimestamp,
      currentPage,
      pageSize,
      displayedArray,
      handlePageChange,
      getItemIndex
    }
  }
}
</script>

  <style scoped>

  .array-container {
    padding: 10px;
  }

  .object-type-container {
    margin-left: 50px;
  }
.array-list {
    list-style-type: none;
    padding: 0;
    margin-bottom: 0px;
}

.array-index {
    background-color: var(--light-grey);
    height: 23px;
    line-height: 23px;
    border-radius: 2px;
    margin-right: 8px;
    min-width: 23px;
    padding: 0 4px;
    text-align: center;
    color: rgba(4,30,73,0.7);
    display: inline-block;
    flex: 0 0 auto;
    font-family: "Roboto Mono",monospace;
    font-size: 13px;
    align-self: flex-start;
    flex-shrink: 0;
}
.index-box {
    padding: 3px;
    display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;
}
.index-box:hover {
    background-color: var(--light-grey);
    border-radius: 4px;
}

.index-and-value-container:hover .edit-btn,
.index-and-value-container:hover .delete-btn {
  visibility: visible;
}

.object-container {
  display: flex;
  flex-direction: column;
  align-self: stretch;
}

.object-field {
  display: flex;
  align-items: baseline;
  margin-left: 25px;

}

.object-key {
  color: grey;
}

.object-value {
  color: rgba(0, 0, 0, 0.761);
}
  .filter-row {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    font-size: 13px !important;
  }

  .header-section {
    display: flex;
    align-items: center;
  }

  .medium-icon {
    font-size: 16px;
    color: #a09e9e;
  }

  .document-title {
    color: #3f414d;
  }

  .filter-row span {
    white-space: nowrap;
    margin-right: 8px;
  }

  .filter {
    flex: 1;
    margin-right: 8px;
  }

  .filter-select {
    min-width: 190px;
  }

  .filter-content {
    margin: 10px 10px 20px 10px;
    display: flex;
    flex-direction: column;
  }

  .filter-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid var(--border-color);
    padding-top: 15px;
    margin-left: -15px;
    margin-right: -15px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .filter-label-input {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 10px;
    position: relative;
  }

  .filter-label-input label {
    margin-bottom: 10px;
  }

  .filter-actions {
    display: flex;
    justify-content: flex-end;
    padding-top: 10px;
  }

  .action-buttons {
    display: flex;
  }

  .filter-label-input label {
    margin-bottom: 0.5rem;
  }

  .filter {
    width: 100%;
  }

  .invalid-input-message {
    color: #ff4d4f;
    font-size: 11px;
    position: absolute;
    bottom: -20px;
    left: 0;
    visibility: hidden;
  }

  .filter-label-input .is-invalid + .invalid-input-message {
    visibility: visible;
  }

  .action-btn {
    background-color: #e1e5e8;
    color: black;
    font-size: 13px !important;
  }

  .apply-btn {
    background-color: green;
    color: white;
  }

  .apply-btn:hover {
    color: white;
    background-color: darkgreen;
  }

  .object-field {
  display: flex;
  align-items: flex-start;
  padding: 8px;
}

.object-field:hover {
    background-color: var(--light-grey);
    border-radius: 4px;
}

.index-and-value-container:hover {
  background-color: var(--light-grey);
    border-radius: 4px;
}

.index-and-value-container{
   display: flex;
  align-items: center;
  padding: 10px;
  margin-left: 40px;
}

.object-key {
  margin-right: 8px;
}

.edit-btn,
.delete-btn {
  visibility: hidden;
}

.object-field:hover .edit-btn,
.object-field:hover .delete-btn {
  visibility: visible;
}

.edit-btn,
.delete-btn {
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  transition: none;
}

.button-container {
  display: flex;
  margin-left: 40px;

}

.medium-icon {
  font-size: 15px;
}

.index-box:hover .edit-btn,
.index-box:hover .delete-btn {
  visibility: visible;
}

.pagination-container {
  display: flex;
  justify-content: center;
}

  </style>

  <style>
  .el-table__cell.el-table__expanded-cell {
  padding: 0 !important;
}
  </style>
